import React from "react"
import BaseIcon from "../../BaseIcon"

export default class PlusButtonIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <circle
        fill={this.getColor()}
        cx="6.5"
        cy="6.5"
        r="6.5"
      />
      <polygon
        fill={"#fff"}
        fillRule={"evenodd"}
        points="10 6 7 6 7 3 6 3 6 6 3 6 3 7 6 7 6 10 7 10 7 7 10 7 10 6"
      />
    </g>,
  ]
  getViewBox = () => "0 0 13 13"
}
